import React, { useMemo } from 'react';
import styled from 'styled-components';

import { getErrorContent } from 'common/utils';

type Props = {
  error: any;
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ErrorToastContent = ({ error }: Props) => {
  const errorContent = useMemo(() => getErrorContent(error), [error]);
  return <Root>{errorContent}</Root>;
};

export default ErrorToastContent;
